var __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.object.get-own-property-descriptors.js");